import { useEffect, useState } from "react";
import { useLazyFetchRoadLandRightDocumentInfoQuery } from "../../api/rtk/base/slices/documentsApiSlice";
import { formatDateToLocalFormat } from "../../features/dataFunctions/format/date";

export function useLandLotOwnersWithDocuments(rawOwners: any) {
    const [fetchDocInfo] = useLazyFetchRoadLandRightDocumentInfoQuery();
    const [ownersWithDocuments, setOwnersWithDocuments] = useState<any>(null);
    const [isFetching, setIsFetching] = useState<boolean>(true);

    useEffect(() => {
        if (!rawOwners?.length) {
            setOwnersWithDocuments(null);
            return;
        }

        setIsFetching(true);

        (async () => {
            const ownersWithDocuments = await Promise.all(
                rawOwners.map(async (owner: any) => {
                    const { DocID, RightEstablishmentDocID } = owner ?? {}
                    if (!DocID && !RightEstablishmentDocID) return owner;
                    try {
                        if (DocID) {
                            const { data } = await fetchDocInfo({ id: DocID });
                            const { Name, RegistrationDate, Number, ["DocPreview@xdata.proxy"]: PreviewData, ["Data@xdata.proxy"]: DownloadData } = data ?? {}
                            const requisitesParts = [
                                Name,
                                RegistrationDate && `от ${formatDateToLocalFormat(RegistrationDate)}\n`,
                                Number && `№ ${Number}`
                            ]
                            const requisites = requisitesParts.filter(Boolean).join(" ");
                            owner = {
                                ...owner,
                                RightCertificationDocRequisites: requisites,
                                RightCertificationDocPreviewData: PreviewData,
                                RightCertificationDocDownloadData: DownloadData
                            };
                        }
                    } catch { }
                    try {
                        if (RightEstablishmentDocID) {
                            const { data } = await fetchDocInfo({ id: RightEstablishmentDocID });
                            const { Name, RegistrationDate, Number, ["DocPreview@xdata.proxy"]: PreviewData, ["Data@xdata.proxy"]: DownloadData } = data ?? {}
                            const requisitesParts = [
                                Name,
                                RegistrationDate && `от ${formatDateToLocalFormat(RegistrationDate)}\n`,
                                Number && `№ ${Number}`
                            ]
                            const requisites = requisitesParts.filter(Boolean).join(" ");
                            owner = {
                                ...owner,
                                RightEstablishmentDocRequisites: requisites,
                                RightEstablishmentDocPreviewData: PreviewData,
                                RightEstablishmentDocDownloadData: DownloadData,
                            };
                        }
                    } catch { }
                    return owner
                })
            );
            setOwnersWithDocuments(ownersWithDocuments);
            setIsFetching(false);
        })();


    }, [rawOwners, fetchDocInfo])

    return { owners: ownersWithDocuments, isFetching }
}